import { render, staticRenderFns } from "./pizza.vue?vue&type=template&id=f811dd2e&scoped=true&"
import script from "./pizza.vue?vue&type=script&lang=js&"
export * from "./pizza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f811dd2e",
  null
  
)

export default component.exports